var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"info",staticClass:"px-10 pt-5 pb-3 leading-base break-words survey-title"},[_c('div',{ref:"titleContainer",staticClass:"title text-20 font-bold mb-3 text-center",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('div',{ref:"descContainer",staticClass:"desc box-border text-theme-black-650",domProps:{"innerHTML":_vm._s(_vm.welcome)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }